// extracted by mini-css-extract-plugin
export default {"container":"Monitor1_container__Y1Ut1","rows":"Monitor1_rows__yXu0e"};